<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text" cdkDragHandle>
      RPC for: {{ workOrderNumber }}
    </div>
    <button mat-icon-button class="close-btn" (click)="onSave()">
      <mat-icon>close</mat-icon>
    </button>
</div>  
<mat-dialog-content>    
    <form [formGroup]="editForm" (ngSubmit)="onSave()" class="form-grid">
        <div class="form-grid-row">
            <mat-form-field appearance="outline">
                <mat-label>RPC Type</mat-label>
                <mat-select formControlName="rpcType" required data-testid="rpcType">
                    <mat-option [value]="null">-Select Expense Type-</mat-option>
                    @for (type of rpcTypes; track type.id) {
                    <mat-option [value]="type.id">{{ type.name }}</mat-option>
                    }
                </mat-select>
                @if (editForm.get('rpcType')?.invalid && editForm.get('rpcType')?.touched) {
                    <mat-error>RPC Type is required</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Count</mat-label>
                <input matInput type="text" data-testid="rpCcount" formControlName="rpCcount" required
                    (input)="roundOff($event, 9999, 0, 'rpCcount')">
                @if (editForm.get('rpCcount')?.invalid && editForm.get('rpCcount')?.touched) {
                    <mat-error>count is required</mat-error>
                }
            </mat-form-field>
            <button mat-raised-button color="primary" type="button" data-testid="btnAddrpc" (click)="onSubmitRow()"
                style="width: 100px; margin-top: 10px;" [disabled]="!canSave">
                <mat-icon>add</mat-icon> {{btnName}}
            </button>
        </div>
    </form>
    
    <div class="mat-elevation-z2 viewport gridheight">
        <table mat-table [dataSource]="dataSource" [trackBy]="trackByRpcId" style="table-layout: fixed;">
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let row">
                <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="onEditRow(row)">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button type="button" color="warn" title="Delete" (click)="onDeleteRow(row.id, getRPCTypeName(row.rpcTypeId), row)" style="color: red;">
                    <mat-icon>delete</mat-icon>
                </button>
                </td>
            </ng-container>
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> ID </th>
                <td mat-cell *matCellDef="let row">{{ row.id }}</td>
            </ng-container>

            <ng-container matColumnDef="rpcTypeId">
                <th mat-header-cell *matHeaderCellDef> RPC Type </th>
                <td mat-cell *matCellDef="let row">{{ getRPCTypeName(row.rpcTypeId) }}</td>
            </ng-container>

            <ng-container matColumnDef="rpCcount">
                <th mat-header-cell *matHeaderCellDef> Count </th>
                <td mat-cell *matCellDef="let row">{{ row.rpCcount }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">No RPC types found.</td>
            </tr>
        </table>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-primary data-testid="btnSave" (click)="onSave()"
        [disabled]="dataSource.data.length === 0 && !editRow">Close</button>
    <!-- <button mat-raised-button color="primary" mat-primary (click)="onClose()">Close</button> -->
</mat-dialog-actions>  